var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_145_42)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_145_42",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_145_42",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_145_42",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD0klEQVR4nO2cS4scVRiGj46KyUJBjQriJUS34kJEUUGCCbpwWV6iMPbUeZ8zM80g/Qs6S1Ewihck6ErNHxCycSXxRrzibUQjuBNM1IgQjbeSY6phhGF0ZrrqnKn6HnhhmG7o/h5OH05/9XU5ZxiGYRiGYRiGYayfsiyvBYaSDkn6APge+C1G0on4v/qxRWDXBl6iv4zH43O89w9Keguo1pk3gX1FUcykriNrgLskfbkBwf+KpC+AvanryQ5gu6QXNit4lRwcjUbbUteXBfPz85cC7zcgebK63x0MBjtc3yXrzMe8Eckrt5Leyga2N7mSV1vZs7Oz57u+oWb25P/K865PAHsTSJ6s7LtdX87JmsIRbhNZ7sU5G3gooeTJqr7fdR3g7QxEv+F60LuoMshf3vudrqsAwwwkT1Z1cF1F0qHUglfkZddVgA8zEDzJe66rSDqRgeBJvnNdBTidgeB/IulX11XIQPDKuK5CBnJNNCZ6amB7dDvITh3tgJ2j2wF4JaOt4yXXVXRm0CUX0d3tdQC7YucsteT4HkII17guo41NIE07R1zXAfalFu29v9d1naIoZtqY5Vhjb/6sF9cMIyGEPQlX827XJ4CDCUQ/5/rGaDTaFqeHWpT8Ti8nlSJxHq6l/XoZuMT1mcFgsAM42uRK7u2A42rbSJyLa2JP7u12sRaS7qw/5ps+wvXudLFeiqKYCSE8EKeJ1vl1PT73CHDfeDw+O3UdWwrv/c7Y/IkzGHGWuu5nn65zPLY642PxOZ3vXRiGYRiGYRiGYfQG4ELgFu+9gCeBw7EDF9upkr4Ffomp/16uf3x0WNIBwHvvb15aWrogdR3Zsbi4eHl9wfZFSV9PsXN3LP46N/ZNyrK8zPUR7/0Nkh4DPm2h6T9pOH0s6dGyLK93XQa4StIj9S172pC7ZhtV0v4QwnWuKwC3Aa9mMqG02kp/DbjHOXeW22oURXFeCKGU9EkGMqv/uco/8t4/DJzrtgJxdQBfpRbHxoXHGwIU2a7wEMJN9VWR5LKYjvDXgRtdZreF2A/8kVoO05f9J/BU8u0kXj6q7zVXdTxH4w0DUkm+AziZgYSqpfzovb+9VcnxBeuvwlWfIulUCOHWViQPh8OL6yvQVU9zvCzLixoXDTyRQbFV4jzeuOjEN56qMsnnbYg+lUGhVcpI+rlx0cA3qQslfY61IfrpDAqtEq/oA42LDiFcIemH1MWSLicXFhaubFx0LXuPpJ8yKLpK8KVld+uTnsCz8RQi6fcMJFRNJNZW1/jM3Nzc1a1KNgzDMAzDMAzDMAzDcHnyN9SifBdPTthYAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.a5841a4ff0519bb099e7bb871bd3e739.svg";
export { ForwardRef as ReactComponent };